document.addEventListener('DOMContentLoaded', function() {
  const utmCheckLocalStorage = sessionStorage.getItem('utmData');
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  
  // Move these OUTSIDE the if statement
  const popUpSource = document.getElementById('urlSource');
  const popUpMedium = document.getElementById('urlMedium');
  const popUpCampaign = document.getElementById('urlCampaign');
  const popUpContent = document.getElementById('urlContent');
  const popUpTerm = document.getElementById('urlTerm');
  
  if(queryString.includes('?')) {
    const source = urlParams.get('utm_source');
    const medium = urlParams.get('utm_medium');
    const campaign = urlParams.get('utm_campaign');
    const content = urlParams.get('utm_content');
    const term = urlParams.get('utm_term');
    const fbook = urlParams.get('fbclid');
    const search = urlParams.get('keyword');
    
    if(source == null){
      if(fbook == null) {
        if(search != null) {
          popUpSource.value = "search";
        }
      } else {
        popUpSource.value = "Facebook";
      }
      popUpMedium.value = "";
      popUpCampaign.value = "";
      popUpContent.value = "";
    } else {
      popUpSource.value = source;
      popUpMedium.value = medium;
      popUpCampaign.value = campaign;
      popUpContent.value = content;
      popUpTerm.value = term;
      const utmData = {
        utm_source: source,
        utm_medium: medium,
        utm_campaign: campaign,
        utm_content: content,
        utm_term: term
      };
      sessionStorage.setItem('utmData', JSON.stringify(utmData));
    }
  } else if(utmCheckLocalStorage != null) {
    const utmDATA = JSON.parse(utmCheckLocalStorage);
    popUpSource.value = utmDATA.utm_source;
    popUpMedium.value = utmDATA.utm_medium;
    popUpCampaign.value = utmDATA.utm_campaign;
    popUpContent.value = utmDATA.utm_content;
    popUpTerm.value = utmDATA.utm_term;
  } else {
    document.getElementById('urlSource').value = "CTG";
  }
});